import { Box, BoxProps, CircularProgress } from '@mui/material';

type LoaderComponentProps = {
	size?: number;
	bgColor?: string;
} & BoxProps;

const LoaderComponent = ({ size = 40, bgColor = 'transparent', ...props }: LoaderComponentProps) => (
	<Box
		{...props}
		sx={{
			display: 'inline-block',
			alignItems: 'center',
			alignContent: 'center',
			textAlign: 'center',
			width: '100%',
			backgroundColor: bgColor,
			...props.sx
		}}
		minHeight={`${size}px`}
	>
		<CircularProgress size={size} 
			sx={{
				color: '#00B9FF !important',

				'& .MuiCircularProgress-svg': {
					color: '#00B9FF !important',
				},

				'& .MuiCircularProgress-circle': {
					stroke: '#00B9FF !important',
				},
			}} 
		/>
	</Box>
);

export default LoaderComponent;
